import { __classPrivateFieldGet } from '../node_modules/tslib/tslib.es6.js';
import Config from '../config/index.js';
import { stringToFloat, isNumber } from '../utils/number.js';
import LocaleWrapper from './locale-wrapper.js';
import { isString } from '../utils/string.js';

var _Money_instances, _Money_currencyValue_get, _Money_numberFormatterLocale_get, _Money_numberFormatterOptions_get;
const LOCALE_BY_CURRENCY = {
  KGS: 'ru-KG',
  kgKGS: 'ru-KG',
  ruKGS: 'ru-KG',
  enKGS: 'ru-US'
};
class Money {
  constructor(value, currency) {
    _Money_instances.add(this);
    if (isString(value)) {
      const formattedValue = stringToFloat(value);
      this.value = isNumber(formattedValue) ? formattedValue : 0;
    } else {
      this.value = isNumber(value) ? value : 0;
    }
    this.currency = currency;
  }
  toString() {
    try {
      const formatter = new Intl.NumberFormat(__classPrivateFieldGet(this, _Money_instances, "a", _Money_numberFormatterLocale_get), __classPrivateFieldGet(this, _Money_instances, "a", _Money_numberFormatterOptions_get));
      return formatter.format(this.value);
    } catch (error) {
      return `${this.value} ${__classPrivateFieldGet(this, _Money_instances, "a", _Money_currencyValue_get)}`;
    }
  }
  toObject() {
    return this;
  }
}
_Money_instances = new WeakSet(), _Money_currencyValue_get = function _Money_currencyValue_get() {
  return this.currency || Config.money.fallbackCurrency;
}, _Money_numberFormatterLocale_get = function _Money_numberFormatterLocale_get() {
  if (__classPrivateFieldGet(this, _Money_instances, "a", _Money_currencyValue_get) !== 'KGS') return LocaleWrapper.locale;
  const key = `${LocaleWrapper.locale}${__classPrivateFieldGet(this, _Money_instances, "a", _Money_currencyValue_get)}`;
  return LOCALE_BY_CURRENCY[key];
}, _Money_numberFormatterOptions_get = function _Money_numberFormatterOptions_get() {
  return {
    style: 'currency',
    currency: __classPrivateFieldGet(this, _Money_instances, "a", _Money_currencyValue_get),
    maximumFractionDigits: Config.money.maximumFractionDigits,
    maximumSignificantDigits: Config.money.maximumSignificantDigits,
    currencyDisplay: Config.money.currencyDisplay
  };
};

export { Money as default };
